import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../css/Formulario_Pacientes.css';

const preguntas = [
  { id: 'p1', texto: '1. ¿ Se le entregó el diario al paciente?' },
];

const InicioTratamiento = () => {
  const { idPaciente, visita } = useParams();
  const [respuestas, setRespuestas] = useState({});
  const [comentarios, setComentarios] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [bloqueado, setBloqueado] = useState(false);
  const navigate = useNavigate();

  const tipoFormulario = `inicio_tratamiento_visita_${visita}`;
  const BLOQUEO_KEY = `formulario_bloqueado_${idPaciente}_${tipoFormulario}`;

  useEffect(() => {
    const bloqueoGuardado = localStorage.getItem(BLOQUEO_KEY);
    if (bloqueoGuardado === 'true') setBloqueado(true);

    if (idPaciente && visita) {
      fetchFormulario();
    }
  }, [idPaciente, visita]);

  const fetchFormulario = async () => {
    try {
      const res = await fetch(`https://api.weareinfinite.mx/form/formularios/${idPaciente}/${tipoFormulario}`);
      if (!res.ok) throw new Error('Formulario no encontrado');

      const data = await res.json();
      const respuestasApi = data.respuestas || [];

      const newRespuestas = {};
      const newComentarios = {};

      respuestasApi.forEach(r => {
        newRespuestas[r.id] = r.respuesta;
        newComentarios[r.id] = r.comentario || '';
      });

      setRespuestas(newRespuestas);
      setComentarios(newComentarios);
      setEditMode(true);
    } catch (error) {
      console.warn('No se encontró un formulario previo:', error.message);
      setEditMode(false);
    }
  };

  const handleChange = (id, value) => {
    setRespuestas(prev => ({ ...prev, [id]: value }));
  };

  const handleComentarioChange = (id, value) => {
    setComentarios(prev => ({ ...prev, [id]: value }));
  };

  const validarCampos = () => {
    for (let pregunta of preguntas) {
      if (!respuestas[pregunta.id]) {
        Swal.fire('Advertencia', `Por favor, responde: ${pregunta.texto}`, 'warning');
        return false;
      }
    }
    return true;
  };

  const construirPayload = () => ({
    idPaciente,
    tipoFormulario,
    respuestas: preguntas.map(p => ({
      id: p.id,
      respuesta: respuestas[p.id],
      comentario: comentarios[p.id] || ''
    })),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validarCampos()) return;

    const payload = construirPayload();

    try {
      const method = editMode ? 'PUT' : 'POST';
      const url = editMode
        ? `https://api.weareinfinite.mx/form/formularios/${idPaciente}/${tipoFormulario}`
        : `https://api.weareinfinite.mx/form/formularios`;

      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error(await res.text());

      Swal.fire('Éxito', editMode ? 'Formulario actualizado' : 'Formulario guardado', 'success')
        .then(() => {
          fetchFormulario();
          navigate(`/Cronograma/${idPaciente}`);
        });
    } catch (error) {
      Swal.fire('Error', 'Error al enviar datos: ' + error.message, 'error')
        .then(() => {
          navigate(`/Cronograma/${idPaciente}`);
        });
    }
  };

  const bloquearFormulario = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Una vez bloqueado, solo podrá desbloquearse con contraseña.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, bloquear',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.setItem(BLOQUEO_KEY, 'true');
        setBloqueado(true);
        Swal.fire('Formulario Bloqueado', 'Los campos están ahora bloqueados.', 'info');
      }
    });
  };

  const desbloquearFormulario = () => {
    Swal.fire({
      title: 'Desbloquear formulario',
      input: 'password',
      inputLabel: 'Introduce la contraseña',
      inputPlaceholder: 'Contraseña',
      showCancelButton: true,
      confirmButtonText: 'Desbloquear',
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value === 'infinite') {
          localStorage.removeItem(BLOQUEO_KEY);
          setBloqueado(false);
          Swal.fire('Formulario Desbloqueado', 'Puedes editar nuevamente los datos.', 'success');
        } else {
          Swal.fire('Contraseña incorrecta', 'No se puede desbloquear el formulario.', 'error');
        }
      }
    });
  };

  if (!idPaciente || !visita) {
    return (
      <div className="fondo">
        <div className="container glass">
          <h2 style={{ color: 'white' }}>Faltan datos en la URL: ID de paciente o visita.</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="fondo">
      <div className="container glass">
        <img src="/image001.png" alt="Logo Infinite" className="logo" />
        <h2 style={{ color: '#ff5733' }}>Entrega de Diario - Visita {visita}</h2>

        <form onSubmit={handleSubmit}>
          {preguntas.map(pregunta => {
            const respuesta = respuestas[pregunta.id];
            const esNo = respuesta === 'No';

            return (
              <div
                className="pregunta"
                key={pregunta.id}
                style={{
                  border: esNo ? '2px solid red' : '1px solid transparent',
                  borderRadius: '8px',
                  padding: '10px',
                  marginBottom: '15px',
                }}
              >
                <span dangerouslySetInnerHTML={{ __html: pregunta.texto }} />
                <div className="radio-group">
                  {['Si', 'No'].map(op => (
                    <label className="radio-option" key={op}>
                      <input
                        type="radio"
                        name={pregunta.id}
                        value={op}
                        checked={respuesta === op}
                        onChange={() => handleChange(pregunta.id, op)}
                        disabled={bloqueado}
                      />
                      <span className="custom-radio">{op}</span>
                    </label>
                  ))}
                </div>
                {esNo && (
                  <input
                    type="text"
                    className="comentario-input"
                    placeholder="Ingrese una observación..."
                    value={comentarios[pregunta.id] || ''}
                    onChange={(e) => handleComentarioChange(pregunta.id, e.target.value)}
                    disabled={bloqueado}
                  />
                )}
              </div>
            );
          })}

          <div className="btn-container">
            {bloqueado ? (
              <button type="button" onClick={desbloquearFormulario}>Desbloquear</button>
            ) : (
              <button type="button" onClick={bloquearFormulario}>Bloquear</button>
            )}
            <button type="submit" disabled={bloqueado}>
              {editMode ? 'Actualizar' : 'Enviar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InicioTratamiento;
